import { render, staticRenderFns } from "./DashboardBanner.vue?vue&type=template&id=4aad063c&scoped=true"
import script from "./DashboardBanner.vue?vue&type=script&lang=js"
export * from "./DashboardBanner.vue?vue&type=script&lang=js"
import style0 from "./DashboardBanner.vue?vue&type=style&index=0&id=4aad063c&prod&lang=scss"
import style1 from "./DashboardBanner.vue?vue&type=style&index=1&id=4aad063c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad063c",
  null
  
)

export default component.exports